(function ($, njm) {
    'use strict';

    njm.views.pagination = Backbone.View.extend({

        events: {
            'keydown #pageInput': 'validate',
            'click #pageForm a': 'submit',
            "submit #pageForm": "fnPagination"
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$input = this.$('input');
            var currentPage = this.urlParam("page");
            window.addEventListener("pageshow", function (event) {
                if (currentPage != "undefined" && currentPage != null && currentPage != false) {
                    document.getElementById("pageInput").value = currentPage;
                }
                else {
                    document.getElementById("pageInput").value = "1";
                }
            });

        },




        urlParam: function (name) {
            name = name.toLowerCase();
            var location = window.location.search,
                index = location.indexOf('='),
                locationCheck = location.substring(0, index).toLowerCase() + location.substring(index);

            var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                .exec(locationCheck);
            return (results !== null) ? results[1] || 0 : 1;
        },

        /**
         * Validate
         */
        validate: function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||

                // Allow: Ctrl/cmd+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||

                // Allow: Ctrl/cmd+C
                (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||

                // Allow: Ctrl/cmd+X
                (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||

                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {

                // let it happen, don't do anything
                return;
            }

            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }

            // Allow: maximum number of characters
            this.maxChar = 3;
            if ($(e.currentTarget).val().length >= this.maxChar) {
                e.preventDefault();
            }

            //this.$input.removeClass('error');

        },

        fnPagination: function () {
            var pageInput = $('input[name=page]').val();
            var totalPageCount = $(".last").text();
            if (pageInput !== undefined && totalPageCount !== undefined) {
                if (pageInput.length == 0 || parseInt(pageInput) < 1) {
                    pageInput = 1
                }
                else if (parseInt(totalPageCount) < parseInt(pageInput)) {
                    pageInput = totalPageCount
                }
                $('input[name=page]').val(pageInput).trigger('change');
            }
        },

        /**
         * Submit
         */
        submit: function (e) {
            e.preventDefault();
            this.currPage = Number(this.$input.val());
            this.lastPage = Number(this.$('.last').text());

            if ((!this.currPage) || (this.currPage > this.lastPage)) {
                this.$input.addClass('error');
                e.preventDefault();
            }
            var pageNumber = $(e.currentTarget).attr('pageno');
            //check first the hidden variable if set
            //   var query = '';
            //   var category = '';
            //   //if($('#pagerQuery').val() ==='')
            //   query = $('#searchInput').attr('placeholder');
            //   $('#pagerQuery').val(query);
            ////   if ($('#pagerCategory').val() === '')
            //   category = $('#searchInputCategory').val();
            //   $('#pagerQuery').val(query);
            //   //searchInputCategory
            //   $('#pagerCategory').val(category);
            $('#pageInput').val(pageNumber);
            $('#pageForm')[0].submit();
        }
    });
})(jQuery, njm);
